export default __webpack_public_path__ + "static/media/cardboard.6be6acc8.svg";